import styled from 'styled-components';
import { Select } from 'antd';
import { Input } from 'antd';

const { TextArea } = Input;

export const SelectContainer = styled.div`
  .ant-select-item {
    padding: 7.5px 16px;
  }
`;

export const StyledSelect = styled(Select)`
  .ant-select-selector {
    height: 100% !important;
    border-radius: 8px !important;

    input {
      height: 100% !important;
    }

    .ant-select-selection-item {
      vertical-align: text-bottom;
    }

    .ant-select-selection-placeholder {
      height: 100%;
      color: #808080;
      vertical-align: text-bottom;
    }
  }
`;

export const StyledTextArea = styled(TextArea)`
  border-radius: 8px;
  padding: 12px;
  &::placeholder {
    color: #808080;
    opacity: 1;
  }
  &::-webkit-scrollbar {
    width: 5px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background: #d9d9d9c9;
    border-radius: 10px;
  }
  @-moz-document url-prefix() {
    .rc-virtual-list-holder {
      scrollbar-width: thin;
      scrollbar-color: #d9d9d9c9 transparent;
    }
  }
`;
